import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef, useImperativeHandle, useRef, } from 'react';
import clsx from 'clsx';
import { Divider } from '@tribeplatform/react-ui-kit/Divider';
import { MenuList } from '../../components/MenuList';
export const SlashMenuList = forwardRef(({ items, command }, ref) => {
    const refs = useRef([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const selectItem = index => {
        const item = items[index];
        if (item) {
            command(item);
        }
    };
    const upHandler = () => {
        const nextSelectedItem = items[selectedIndex - 1];
        let step = -1;
        if ((nextSelectedItem === null || nextSelectedItem === void 0 ? void 0 : nextSelectedItem.type) === 'divider') {
            step = -2;
        }
        setSelectedIndex((selectedIndex + items.length + step) % items.length);
    };
    const downHandler = () => {
        const nextSelectedItem = items[selectedIndex + 1];
        let step = 1;
        if ((nextSelectedItem === null || nextSelectedItem === void 0 ? void 0 : nextSelectedItem.type) === 'divider') {
            step = 2;
        }
        setSelectedIndex((selectedIndex + step) % items.length);
    };
    const enterHandler = () => {
        selectItem(selectedIndex);
    };
    useEffect(() => setSelectedIndex(0), [items]);
    useEffect(() => {
        const el = refs.current[selectedIndex];
        if (el) {
            el.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'start',
            });
        }
    }, [selectedIndex]);
    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));
    if (!items || items.length === 0) {
        return null;
    }
    return (_jsx(MenuList, { children: items.map((item, index) => {
            if (item.type === 'divider') {
                // eslint-disable-next-line react/no-array-index-key
                return _jsx(Divider, {}, `divider-${index}`);
            }
            return (_jsxs("span", { ref: el => {
                    refs.current[index] = el;
                }, className: clsx(index === selectedIndex
                    ? 'bg-surface-subdued text-content'
                    : 'bg-surface text-content', 'flex items-center px-4 py-2 space-s-2 cursor-pointer'), onClick: () => selectItem(index), children: [_jsx("div", { className: "w-4 h-4 flex items-center", children: item.icon }, void 0), _jsx("div", { children: item.label }, void 0)] }, item.label));
        }) }, void 0));
});
//# sourceMappingURL=SlashList.js.map